import { getMerchant } from "@api/merchant";
import { OIDC_COOKIES } from "@lib/auth";
import Cookies from "js-cookie";
import { computed } from "nanostores";
import type { Merchant } from "src/types/merchant";
import { $extdev, $testMode } from "./extdev";
import { createFetcherStore } from "./fetcher";
import { $authed } from "./user";

export const $merchant = createFetcherStore<Merchant>(
  [$authed, "v1/merchants/", ""],
  {
    fetcher: async () => {
      // biome-ignore lint/style/noNonNullAssertion: FIXME
      const claimsCookie = Cookies.get(OIDC_COOKIES.Claims)!;
      const claims = JSON.parse(claimsCookie);
      const merchantCode = claims?.classic?.merchant_code as unknown as string;
      const merchant = await getMerchant(merchantCode);
      if (merchant.extdev) {
        $testMode.set(true);
      }
      return merchant;
    },
  },
);

// merchantCode store is helper for obtaining merchant code of currently selected merchant.
// In the future this should be handled by proper merchant switch but for now extdev accounts are associated
// with merchants and as such the merchantCode depends on: current merchant, whether test mode is enabled, and the loaded extdev account.
// If the user is in a test mode and we loaded the extdev account the merchant code is set to the merchant code of the extdev.
// Otherwise we take the merchant code of the merchant the user is currently logged into.
export const $merchantCode = computed(
  [$testMode, $extdev, $merchant],
  (
    testMode,
    { data: extdev, loading: extdevLoading },
    { data: merchant, loading: merchantLoading },
  ) => {
    if (merchantLoading || extdevLoading) {
      return undefined;
    }

    if (testMode && extdev) {
      return extdev.classic.merchant_code;
    }

    if (merchant) {
      return merchant.merchantCode;
    }

    return undefined;
  },
);
